import { useNavigate, useParams } from "react-router-dom";
import AppInfo from "../../Pages/Report/AppInfo";
import {
  ChangeReportStatus,
  GetSpecificRowReport,
} from "../../Redux/Reducers/ReportStage/Report";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import AboutProject from "../../Pages/Report/AboutProject";
import ProgressReportInformation from "../../Pages/Report/ProgressReportInformation";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import SubObjectivesCheckBox from "../../Pages/Report/SubObjectivesCheckBox";
import ActivitesTableCheckBox from "../../Pages/Report/ActivitesTableCheckBox";
import BugetItemCheckbox from "../../Pages/Report/BugetItemCheckbox";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import { StartProgressReport } from "../../Redux/Reducers/ReportStage/StartProgressReport";
import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";

const AddStagesContainers = () => {
  const navigate = useNavigate();

  const [ReportDuration, setReportDuration] = useState(null);
  const StartProgressReportResult = useSelector(
    (state) => state.StartProgressReportReducer.StartProgressReportReducer
  );
  const arrayDataCheckBoksActivitesList = useSelector(
    (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["ActivitesList"]
  );
  const arrayDataCheckBoksSubObjectivesList = useSelector(
    (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["SubObjectives"]
  );
  const arrayDataCheckBoksbudgetItemsList = useSelector(
    (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["budgetItems"]
  );

  const ReportRow = useSelector((state) => state.ReportStatus.ReportRow);

  const dispatch = useDispatch();

  const { reportId } = useParams();
  useEffect(() => {
    dispatch(GetSpecificRowReport({ reportId: reportId }));
  }, [reportId]);

  const StartProgressReportFunction = async () => {
    console.log(arrayDataCheckBoksbudgetItemsList, "sssssssssdwd");

    const resultStartProgressReportFunction = await dispatch(
      StartProgressReport({
        rS_NT_AddListActivitiesForStageModel:
          arrayDataCheckBoksActivitesList == undefined
            ? []
            : arrayDataCheckBoksActivitesList,
        rS_NT_AddListBudgetItemsForStageModel:
          arrayDataCheckBoksbudgetItemsList == undefined
            ? []
            : arrayDataCheckBoksbudgetItemsList,
        rS_NT_AddListSubObjectivesForStageModel:
          arrayDataCheckBoksSubObjectivesList == undefined
            ? []
            : arrayDataCheckBoksSubObjectivesList,
        rS_NT_ReportStageAddModel: {
          reportDuration: ReportDuration,
          reportId: reportId,
        },
      })
    );
    console.log(
      resultStartProgressReportFunction.payload,
      "ssssssdddqssdwdwdwd"
    );

    if (resultStartProgressReportFunction?.payload?.success === false) {
      Swal.fire({
        title: "الرجاء تعبئة الحقول التالية",
        html: `
                <div style="text-align: right; direction: rtl; font-size: 16px;">
                  <ul style="list-style-type: none; padding: 0;">
                  ${resultStartProgressReportFunction?.payload?.result
                    .map(
                      (msg) =>
                        `<li style="margin-bottom: 8px;">🔸 <strong>${msg}</strong></li>`
                    )
                    .join("")}</ul>`,
        icon: "warning",
        confirmButtonText: "حسناً",
      });
    } else {
      localStorage.removeItem("persist:root");
      dispatch(SetArrayDataCheckBoks());
      navigate("/SRFund/report/ReportStageRequest/");
    }
  };

  const ChangeReportStatusFunction = () => {
    dispatch(
      ChangeReportStatus({
        reportId: reportId,
        reportStatusId: "ffca5d3f-eef7-43b7-9253-518ac1173fc5",
      })
    );
    navigate("/SRFund/report/ReportStageRequest/");
    localStorage.removeItem("persist:root");
    dispatch(SetArrayDataCheckBoks());
  };
console.log(ReportRow,"ssssssssdwdwdwd");

  return (
    <>
      <AppInfo reportId={reportId} />
      {ReportRow?.reportId ? (
        <>
          <AboutProject
            disabled={true}
            ReportRow={ReportRow}
            setOverallProjectObjective={null}
            setExpectedProjectDeliverables={null}
            setAgreementAttachment={null}
            reportId={reportId}
          />
        </>
      ) : (
        <></>
      )}

      <SharedDiv
        showTitle={true}
        titleName="مرحلة التقرير"
        child={[
          <>
            <ProgressReportInformation
              setReportDuration={setReportDuration}
              reportId={reportId}
            />
          </>,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="الأنشطة"
        child={[
          <>
            <ActivitesTableCheckBox reportId={reportId} />
          </>,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="الاهداف الفرعية"
        child={[
          <>
            <SubObjectivesCheckBox reportId={reportId} />
          </>,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان"
        child={[
          <>
            <BugetItemCheckbox reportId={reportId} />
          </>,
        ]}
      />
      <SharedDiv
        showTitle={true}
        titleName="الإجراءات على الطلب"
        child={[
          <>
            <div
              className="containerButtonMAin "
              style={{ justifyContent: "center" }}
            >
              {/* {ReportRow?.reportStatusId ==
                    "e52ab9e0-dffa-4969-a2ba-efd28a41b148" ? ( */}
              <>
                <ButtonAHSF
                  type={"submitter"}
                  onClick={() => {
                    StartProgressReportFunction();
                  }}
                  disabled={false}
                  title={"بدء التقرير المرحلي"}
                  text={"بدء التقرير المرحلي"}
                  show={true}
                />
                <ButtonAHSF
                  type={"submitter"}
                  onClick={ChangeReportStatusFunction}
                  disabled={false}
                  title={"انهاء الدعم"}
                  text={"انهاء الدعم"}
                  show={true}
                />
              </>
              {/* ) : (
                      <></>
                    )} */}

              {/* {ReportRow?.reportStatusId ==
                    "696d7862-9bcb-4c0d-9de0-0d90f03f3d2a" ? (
                      <>
                        <ButtonAHSF
                          type={"submitter"}
                          onClick={() => {
                            const missingFields = [];
      
                            if (
                              !overallProjectObjective ||
                              overallProjectObjective.trim() === ""
                            ) {
                              missingFields.push("الهدف العام للمشروع");
                            }
      
                            if (
                              !expectedProjectDeliverables ||
                              expectedProjectDeliverables.trim() === ""
                            ) {
                              missingFields.push("المخرجات المتوقعة");
                            }
      
                            if (
                              AgreementAttachment &&
                              AgreementAttachment.length > 0
                            ) {
                              missingFields.push("مرفق الاتفاقية");
                            }
      
                            if (missingFields.length > 0) {
                              Swal.fire({
                                title: "الرجاء تعبئة الحقول التالية",
                                html: `
                                        <div style="text-align: right; direction: rtl; font-size: 16px;">
                                          <ul style="list-style-type: none; padding: 0;">${missingFields
                                            .map(
                                              (field) =>
                                                `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                            )
                                            .join("")}</ul>`,
                                icon: "warning",
                                confirmButtonText: "حسناً",
                              });
                              return;
                            }
                            changeReportStatus(
                              "e52ab9e0-dffa-4969-a2ba-efd28a41b148"
                            );
                            EditReportProjectObjectiveFunction();
                          }}
                          disabled={false}
                          title={"التحويل الى الموافقة"}
                          text={"التحويل الى الموافقة"}
                          show={true}
                        />
      
                        <div className="SaveButtonMarks">
                          <ButtonAHSF
                            type={"submitter"}
                            onClick={EditReportProjectObjectiveFunction}
                            disabled={false}
                            // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                            text={"حفظ"}
                            show={true}
                          />
                        </div>
                      </>
                    ) : (
                      <></>
                    )} */}
            </div>
          </>,
        ]}
      />
    </>
  );
};

export default AddStagesContainers;
